import React, { useRef, useEffect, HTMLAttributes } from 'react';
import classNames from 'classnames';
import './texthint.scss';

interface TextHintProps extends HTMLAttributes<HTMLDivElement> {
	children: string;
	onParent?: boolean;
	align?: "left" | "center" | "right";
	isList?: boolean;
	disable?: boolean;
};

/** Компонента для отображения текста, при переполнении текст обрезается и показывается подсказка  */
const TextHint: React.FC<TextHintProps> = ( props ) => {

	const { disable = false, isList = false, align = "left", onParent = true,
		children, style, className, ...otherProps
	} = props;

	const spanRef = useRef<HTMLDivElement>(null);

	useEffect( () => {
		onRecalc();
	// eslint-disable-next-line
	}, [ children, onParent, disable, isList ] );

    const onRecalc = () => {
        if ( disable ) return;
        if ( !spanRef || !spanRef.current ) return;

        const current = spanRef.current;
        const element = onParent ? current.parentElement : current;

        const isOverflowWidth = current.scrollWidth > current.clientWidth;
        const isOverflowHeight = current.scrollHeight > current.clientHeight;
        const isOverflow = isOverflowWidth || isOverflowHeight;

        if (isOverflow) {
            element?.setAttribute("data-tooltip-id", "rdc_tooltip");
            if (isList) {
                const newText = children.replaceAll(",", "</br>");
                element?.setAttribute("data-tooltip-html", newText);
            } else {
                element?.setAttribute("data-tooltip-html", children);
            }
            return;
        }

        element?.removeAttribute("data-tooltip-html");
        element?.removeAttribute("data-tooltip-id");
    };

	return (
		<div
			ref={spanRef}
			className={classNames("rdc_texthint", className)}
			style={{ textAlign: align, ...style }}
			{...otherProps}
		>
			{ children }
		</div>
	);
};

export default TextHint;
